import { Pipe, PipeTransform } from '@angular/core';
import dayjs from 'dayjs/esm';
import 'dayjs/esm/locale/de'; // import locale

dayjs.locale('de'); // use locale

@Pipe({ name: 'duration' })
export class DurationPipe implements PipeTransform {
  transform(start: Date | number, end: Date | number): string {
    const startDay: dayjs.Dayjs = dayjs(start);
    const endDay: dayjs.Dayjs = dayjs(end).add(1, 'day');

    const years = endDay.diff(startDay, 'y');
    const months = endDay.diff(startDay.add(years, 'y'), 'M');
    const days = endDay.diff(startDay.add(years, 'y').add(months, 'M'), 'd');
    const leftoverDays = days % 7;
    const weeks = (days - leftoverDays) / 7;

    const dateParts = [
      { singular: 'Jahr', plural: 'Jahre', value: years },
      { singular: 'Monat', plural: 'Monate', value: months },
      { singular: 'Woche', plural: 'Wochen', value: weeks },
      { singular: 'Tag', plural: 'Tage', value: leftoverDays }
    ];

    const largestUnitIndex = dateParts.findIndex(({ value }) => value > 0);

    return dateParts
      .slice(largestUnitIndex, largestUnitIndex + 2)
      .filter(({ value }) => value > 0)
      .map(({ singular, plural, value }) => `${value} ${value === 1 ? singular : plural}`)
      .join(', ');
  }
}
